import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'as-manage-items-modal',
  templateUrl: './manage-items-modal.component.html',
  styleUrls: ['./manage-items-modal.component.scss']
})
export class ManageItemsModalComponent implements OnInit {

  @ViewChild('table', {static: false}) table;
  @ViewChild("manageItemsModal", {static: false}) manageItemsModal;

  @Input() flatArray; //main data source
  @Input() actions: Array<any>;
  @Input() title;
  @Input() type;
  @Input() placeholder;
  @Input() ModalConfig = {backdrop: true, ignoreBackdropClick: true}

  @Output() handleThisData = new EventEmitter();
  @Output() setDefault = new EventEmitter();

  defaultMemoConfirmationMessage;

  displayAction = {
    'rename': false,
    'delete': false,
    'add': false
  }

  model = {
    name: "",
    catShort: ""
  }

  errors = '';
  errorsList = [];

  collection = {
    type: '',
    delete: {id: null, updatedItems: []},
    collection: [],
    add: []
  }

  constructor() {
  }

  get collectionCount() {
    return this.flatArray.length
  }

  ngOnInit() {

    this.resetCollection()
    this.actions.forEach((e, inx) => {
      this.displayAction[e] = true;
    })

    if (window.localStorage.getItem('defaultMemoConfirmationMessage')) {
      this.defaultMemoConfirmationMessage = window.localStorage.getItem('defaultMemoConfirmationMessage');
    }

    //input example: {name: "Advisory", networkId: 1231, id: 6549684156}

  }

  updateDataFromPagination(event) {
    this.flatArray = event;
  }

  newAddedItemsHandler(event) {

    this.table?.nativeElement.scrollIntoView({behavior: "smooth"})

    setTimeout(() => {

      this.errorsList = []

      if (this.type == 'categories') {

        if (this.model.name != '' && this.model.catShort != '') {
          event = [this.model.name];
        }
        if (this.model.catShort == '') {
          this.errorsList.push("Abbreviation Cannot be empty");
        }

        if (this.model.name == '') {
          this.errorsList.push("Name Cannot be empty");
        }

      }

      if (this.errorsList.length == 0) {
        event.forEach((e, i) => {

          if (this.flatArray.some((f) => (e.toString().trim()) == f.name.toString().trim()) == true) {
            this.errors = "Item with this name already exists";
          } else {
            this.errors = ""
            this.collection.add.push({name: e, id: 0, catShort: this.model.catShort});
            this.flatArray.unshift({name: e, id: 0, catShort: this.model.catShort})

          }
        })
        this.model = {name: "", catShort: ""}
      }
    }, 700)

  }

  delete(id, name) {

    if (id == 0) {
      //deleting an element that does not have an id yet
      this.flatArray.forEach((e, ind) => {
        if (e.name == name) {
          this.flatArray.splice(ind, 1);
        }
      })
    }

    this.flatArray = this.flatArray.reduce((coll, curr, inx) => {

      if (curr.id == id && id != 0) {
        this.collection.delete.id = id;
      }
      if (name != curr.name) {
        coll.push(curr)
      }
      return coll;
    }, [])

    //if we just added new items and want to remove them...

    let addIndex = (this.collection.add.findIndex((s) => s.name == name));

    if (addIndex != -1) {
      this.collection.add.splice(addIndex, 1);
    }

    this.collection.delete.updatedItems = this.flatArray;
    this.collection.collection = this.flatArray;

    this.handleThisData.emit(this.collection);
    this.resetCollection();
  }

  save() {

    //send data
    this.collection.collection = this.flatArray;
    this.handleThisData.emit(this.collection);
    this.manageItemsModal.hide();
    this.resetCollection();

  }

  cancel() {
    this.manageItemsModal.hide();
    this.resetCollection();
  }

  resetCollection() {
    this.errors = ''
    this.collection = {
      type: this.type,
      delete: {id: null, updatedItems: []},
      collection: this.flatArray,
      add: []
    }

  }

  makeDefault(name) {
    this.defaultMemoConfirmationMessage = name;
    this.setDefault.emit(name);
    window.localStorage.setItem('defaultMemoConfirmationMessage', name);
  }
}
